import styled from "styled-components";
import { OrderStatus } from "../../enums";

export const StatusIcon = styled.span`
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  vertical-align: middle;
  cursor: pointer;
  background-color: ${({ $status }) => 
    $status === OrderStatus.pending ? '#f0ad4e' :
    $status === OrderStatus.completed ? '#5cb85c' :
    $status === OrderStatus.canceled ? '#d9534f' :
    '#292b2c'
  };

  &:hover {
    background-color: ${({ $status }) =>
      $status === OrderStatus.pending ? 'rgba(240, 173, 78, 0.7)' :
      $status === OrderStatus.completed ? 'rgba(92, 184, 92, 0.7)' :
      $status === OrderStatus.canceled ? 'rgba(217, 83, 79, 0.7)' :
      'rgba(91, 192, 222, 0.7)'
    };
  }
`;
